import { render, staticRenderFns } from "./Pending.vue?vue&type=template&id=596b182c&scoped=true"
var script = {}
import style0 from "./Pending.vue?vue&type=style&index=0&id=596b182c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596b182c",
  null
  
)

export default component.exports